import { commonAPIConversion } from './api-conversion-common.js';
import { formatRFC3339, parseISO } from 'date-fns';

// ************  PARTNER CONVERSION FUNCTIONS  ************

// ****************************************************************************
// ***  convert partner from API naming convention to UI naming convention  ***
// ****************************************************************************

const convertPartnerFromAPI = (origPartner) => {
    if (!origPartner) {
        return {};
    }
    const partner = commonAPIConversion.convertEntityFromAPI(origPartner);
    if (origPartner.uuid) {
        partner.uuid = origPartner.uuid;
    }
    if (origPartner.birthday) {
        partner.birthday = parseISO(origPartner.birthday);
    }
    if (origPartner.organization_uuid) {
        partner.organizationUuid = origPartner.organization_uuid;
    }
    if (origPartner.partner_type) {
        partner.partnerType = commonAPIConversion.convertOptionFromAPI(origPartner.partner_type);
    }
    if (origPartner.first_name) {
        partner.firstName = origPartner.first_name;
    }
    if (origPartner.middle_name) {
        partner.middleName = origPartner.middle_name;
    }
    if (origPartner.last_name) {
        partner.lastName = origPartner.last_name;
    }
    if (origPartner.full_name) {
        partner.fullName = origPartner.full_name;
    }
    return partner;
};

// *******************************************************
// ***  convert any list of partners from              ***
// ***  API naming convention to UI naming convention  ***
// *******************************************************

const convertPartnerListFromAPI = (origPartnerList) => {
    if (!Array.isArray(origPartnerList)) {
        return [];
    }
    const partnerList = [];
    for (const partner of origPartnerList) {
        partnerList.push(convertPartnerFromAPI(partner));
    }
    return partnerList;
};

// ****************************************************************************
// ***  convert partner from UI naming convention to API naming convention  ***
// ****************************************************************************

const convertPartnerToAPI = (origPartner) => {
    if (!origPartner) {
        return {};
    }
    const partner = commonAPIConversion.convertEntityToAPI(origPartner);
    if (origPartner.uuid) {
        partner.uuid = origPartner.uuid;
    }
    if (origPartner.birthday) {
        partner.birthday = formatRFC3339(origPartner.birthday);
    }
    if (origPartner.organizationUuid) {
        partner.organization_uuid = origPartner.organizationUuid;
    }
    if (origPartner.partnerType) {
        partner.partner_type = commonAPIConversion.convertOptionToAPI(origPartner.partnerType);
    }
    if (origPartner.firstName) {
        partner.first_name = origPartner.firstName;
    }
    if (origPartner.middleName) {
        partner.middle_name = origPartner.middleName;
    }
    if (origPartner.lastName) {
        partner.last_name = origPartner.lastName;
    }
    if (origPartner.fullName) {
        partner.full_name = origPartner.fullName;
    }
    return partner;
};

// *******************************************************
// ***  convert any list of partners from              ***
// ***  UI naming convention to API naming convention  ***
// *******************************************************

const convertPartnerListToAPI = (origPartnerList) => {
    if (!Array.isArray(origPartnerList)) {
        return [];
    }
    const partnerList = [];
    for (const partner of origPartnerList) {
        partnerList.push(convertPartnerToAPI(partner));
    }
    return partnerList;
};

// ****************************************************************
// ***  expose API Utility Method Calls to API Services
// ****************************************************************

export const partnerAPIConversion = {
    convertPartnerFromAPI,
    convertPartnerListFromAPI,
    convertPartnerToAPI,
    convertPartnerListToAPI
};